<template>
  <v-card class="mb-2">
    <v-card-title>{{ $t('account.home.language') }}</v-card-title>
    <v-card-text>{{ language }}</v-card-text>

    <v-card-actions class="justify-center">
      <v-btn color="primary" small :to="{ name: 'account-language' }">
        {{ $t('common.edit') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'LanguageTeaser',
  props: {},
  computed: {
    language() {
      switch (this.$i18n.locale) {
        case 'fr':
          return this.$t('account.language.french')
        case 'en':
          return this.$t('account.language.english')
      }

      return 'en'
    }
  },
  mounted() {},
  methods: {}
}
</script>
